import React from 'react';

// TODO: https://hello.jira.atlassian.cloud/browse/COMPHUB-2159 Replace with @atlaskit/icon-lab icon

// want color of icon to be the same for regular/light/dark modes
import { token } from '@atlaskit/tokens';

export const CarouselExtensionIcon = () => {
	// Moving from <Icon> to <svg> since this icon will be replaced soon
	// and because of the complexity of scaling each path in the SVG.
	return (
		<svg
			width="34"
			height="32"
			viewBox="0 0 34 32"
			fill="none"
			// TODO: Update the attribute below so it is translated.
			// eslint-disable-next-line no-restricted-syntax
			aria-label="Carousel"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect x="0.599609" y="24.7302" width="10" height="6.30769" rx="3.15385" fill="#0055CC" />
			<rect x="11.5996" y="24.7302" width="10" height="6.30769" rx="3.15385" fill="#454F59" />
			<rect x="22.5996" y="24.7302" width="10" height="6.30769" rx="3.15385" fill="#454F59" />
			<rect
				x="1.23038"
				y="1.18155"
				width="31.5385"
				height="20.6051"
				rx="3.15385"
				stroke={token('color.border')}
				strokeOpacity="0.84"
				strokeWidth="1.26154"
			/>
			<path d="M3.8125 19.7685L11.4577 11.5442L19.1029 19.7685H3.8125Z" fill="#CCE0FF" />
			<path d="M7.89746 19.7688L19.1013 7.71631L30.305 19.7688H7.89746Z" fill="#579DFF" />
			<path
				d="M7.43255 10.1951C8.94213 10.1951 10.1659 8.95398 10.1659 7.42298C10.1659 5.89199 8.94213 4.65088 7.43255 4.65088C5.92297 4.65088 4.69922 5.89199 4.69922 7.42298C4.69922 8.95398 5.92297 10.1951 7.43255 10.1951Z"
				fill="#C25100"
			/>
		</svg>
	);
};
